<template>
    <div>
        <ul class="d-flex flex-wrap align-items-center" :class="{'opacity-50': disabled}">
                <li
                class="text-center font-weight-600 m-1 border-dark radius-circle bg-lightest dark fs-smallest"
                style="width: 1.9rem; height: 1.9rem; padding-top: 0.45rem;"
                v-for="day in weekDays"
                :class="{ 'active': day.active, 'pointer':!disabled, 'notAllowed': disabled }"
                @click="toggleDay($event, day)">
                {{ day.nameSmall }}
            </li>
        </ul>
        <span class="dark fs-smaller pointer text-center ml-2">
            <span v-if="value.length == 7" @click="deselectAllWeekDays">Deselect all</span>
            <span v-else @click="selectAllWeekDays">Select all</span>
        </span>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            weekDays: [
                { id: 1, active:false, name: 'Monday', nameSmall:'Mon',  value: 'M' },
                { id: 2, active:false, name: 'Tuesday', nameSmall:'Tue',  value: 'T' },
                { id: 3, active:false, name: 'Wednesday', nameSmall:'Wed',  value: 'W' },
                { id: 4, active:false, name: 'Thursday', nameSmall:'Thu',  value: 'T' },
                { id: 5, active:false, name: 'Friday', nameSmall:'Fri',  value: 'F' },
                { id: 6, active:false, name: 'Saturday', nameSmall:'Sat',  value: 'S' },
                { id: 0, active:false, name: 'Sunday', nameSmall:'Sun',  value: 'S' },
            ],
        }
    },
    props:{
        value: {
            default: function(){
                return []
            },
            type: Array
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: function (newValue, oldValue) {
            this.mutableValue = newValue
            this.updateActiveDays()
        }
    },
    computed:{
        mutableValue: {
            get: function() {
                return this.value
            },
            set: function(newValue) {
                let updatedValue = newValue
                this.$emit('input', updatedValue)
            }
        }
    },
    created: function() {
        this.mutableValue = this.value
        this.updateActiveDays()
    },
    methods: {
        toggleDay: function(event, day) {
            if(this.disabled == true){
                return false
            }

            let newDay = true;
            this.mutableValue.map((storedDay, storedDayIndex) => {
                if(storedDay == day.id){
                    newDay = false;
                    this.mutableValue.splice(storedDayIndex, 1)
                }
            })

            if(newDay){
                this.mutableValue.push(day.id)
            }

            this.updateActiveDays()

            this.$emit('change', this.mutableValue)
        },
        isWeekDayActive: function(schedule, day) {
            return (schedule.repeatsAtWeekDays !== undefined && schedule.repeatsAtWeekDays && schedule.repeatsAtWeekDays.includes(day));
        },
        updateActiveDays: function() {
            this.weekDays.map((weekDay, weekDayIndex) => {
                let removeSelection = true
                this.mutableValue.map(valueDay =>{
                    if(weekDay.id == valueDay){
                        weekDay.active = true
                        removeSelection = false
                    }
                })

                if(removeSelection){
                    weekDay.active = false
                }
            })
        },
        selectAllWeekDays: function() {
            if(this.disabled == true){
                return false
            }
            this.mutableValue = [0, 1, 2, 3, 4, 5, 6]
            this.weekDays.map(weekday => {
                weekday.active = true
            })
            this.$emit('change', this.mutableValue)
        },
        deselectAllWeekDays: function() {
            if(this.disabled == true){
                return false
            }
            this.mutableValue = []
            this.weekDays.map(weekday => {
                weekday.active = false
            })
            this.$emit('change', this.mutableValue)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../../assets/scss/_variables.scss';

    li.active {
        background-color: $color-1 !important;
        border-color: $color-1 !important;
        color: $lightest !important;
    }

</style>



// WEBPACK FOOTER //
// WeekDayPicker.vue?50e7536f